import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { studyModel } from 'src/models/study.model';
import { participantModel, disclosure, participantResponseModel, participantattemptModel, particpantResponse, RaceModel, ApplicantStatusModel, StatusReasonModel } from 'src/models/participant.model';
import { questionModel } from 'src/models/question.model';
import { AppConfig } from 'src/app/app.config';
import { filterPrescreened, applicantsFilter } from 'src/app/model/gridFilter.model';
import { ParticipantDynamicValuesModel, StudyNote } from 'src/app/model/participant.model';
import { AuditParticipants, AuditParticipantsBySP } from 'src/app/model/audit-participants';
import { CommunicationNote } from 'src/app/admin/admin-participant-answers/admin-participant-answers.component';

@Injectable({
  providedIn: 'root'
})
export class ParticipantService {
 
  constructor(private http: HttpClient) { }

  //Get Study Details
  getDummyDetail(): Observable<studyModel> {
    return this.http.get<studyModel>(AppConfig.appsettings.apiRoot + '/values').pipe(catchError(this.handleError));
  }

  //Get Study Details
  getStudyDetail(studyId: string): Observable<studyModel> {
    return this.http.get<studyModel>(AppConfig.appsettings.apiRoot + '/Studiesforparticipants', {
      params: new HttpParams()
        .set("id", studyId.toString())
    }).pipe(catchError(this.handleError));
  }

  getStudyDetailsForParticipant(studyId: string): Observable<studyModel> {
    return this.http.get<studyModel>(AppConfig.appsettings.apiRoot + '/Studiesforparticipants', {
      params: new HttpParams()
        .set("id", studyId.toString())
    }).pipe(catchError(this.handleError));
  }

  getAllParticipants(applicantsFilter: applicantsFilter): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/applicants', applicantsFilter)
      .pipe(catchError(this.handleError));
  }

  getPrescreenedApplicants(preScreenedFilter: filterPrescreened): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/prescreenedapplicants', preScreenedFilter)
      .pipe(catchError(this.handleError));
  }
  getFileterPrescreened(prescreenedFilter: filterPrescreened): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/prescreenedfilter', prescreenedFilter)
      .pipe(catchError(this.handleError));
  }
  getParticipantList(studyId: string): Observable<participantModel[]> {
     const params = new HttpParams().set('studyId', studyId);
     return this.http.get<participantModel[]>(AppConfig.appsettings.apiRoot + '/participant', { params }).pipe(catchError(this.handleError));
  }
  getParticipantListForExport(studyId: string, httpClientRequestTimeOut: string): Observable<any> {
    const params = new HttpParams()
      .set('studyId', studyId)
      .set('httpClientRequestTimeOut', httpClientRequestTimeOut);
     return this.http.get<any[]>(AppConfig.appsettings.apiRoot + '/GetStudyAndParticipantDetails', { params }).pipe(catchError(this.handleError));
  }

  getParticipantAttempt(participantId: string, studyId: string): Observable<participantattemptModel> {
     const params = new HttpParams()
      .set('participId', participantId)
      .set('studyId', studyId);
     return this.http.get<participantattemptModel>(AppConfig.appsettings.apiRoot + '/participantattempt', { params }).pipe(catchError(this.handleError));
  }

  //Get Study List
  getStudyList(): Observable<studyModel[]> {
    const params = new HttpParams().set('isPublish', 'true');
    return this.http.get<studyModel[]>(AppConfig.appsettings.apiRoot + '/study', { params }).pipe(catchError(this.handleError));
  }
  //Get disclosure questions
  getDisclosure(): Observable<questionModel[]> {
    const params = new HttpParams().set('Category', 'Disclosure');
    return this.http.get<questionModel[]>(AppConfig.appsettings.apiRoot + '/question', { params }).pipe(catchError(this.handleError));
  }

  //Get list of questions by study id and category prescreener
  getQuestions(studyid: string, Adminid: boolean = true, Isrefered: string = "false"): Observable<questionModel[]> {
    const params = new HttpParams()
      .set('studyId', studyid)
      .set('questioncategory', 'PreScreener')
      .set('AdminId', String(Adminid))
      .set('IsRefered', Isrefered);
    return this.http.get<questionModel[]>(AppConfig.appsettings.apiRoot + '/questionstudy', { params }).pipe(catchError(this.handleError));
  }

  getStudyQuestions(studyid: string): Observable<any[]> {
    const params = new HttpParams().set('studyId', studyid);
    return this.http.get<questionModel[]>(AppConfig.appsettings.apiRoot + '/GetQuestions', { params }).pipe(catchError(this.handleError));
  }

  getParticipantResponse(studyid: number, participantId: string, questionId: number): Observable<any> {
    const params = new HttpParams()
      .set('studyId', studyid.toString())
      .set('participantId', participantId)
      .set('questionId', questionId.toString());
    return this.http.get<any>(AppConfig.appsettings.apiRoot + '/GetParticipantResponse', { params }).pipe(catchError(this.handleError));
  }

  //Get list of questions by study id and category general
  getGeneralQuestions(studyid: string): Observable<questionModel[]> {
    const params = new HttpParams()
      .set('studyId', studyid)
      .set('questioncategory', 'General');
    return this.http.get<questionModel[]>(AppConfig.appsettings.apiRoot + '/questionstudy', { params }).pipe(catchError(this.handleError));
  }

  getParticipantDynamicValues(studyId: string, Adminid: boolean = true, Isrefered: string = "false"): Observable<ParticipantDynamicValuesModel[]> {
    return this.http.get<ParticipantDynamicValuesModel[]>(AppConfig.appsettings.apiRoot + '/getDynamicParticipantValues', {
      params: new HttpParams()
        .set("studyId", studyId)
        .set("AdminId", String(Adminid))
        .set("IsRefered", Isrefered)
    }).pipe(catchError(this.handleError));
  }
  //Save Demographics Info
  postDemographics(participant: participantModel): Observable<particpantResponse> {
    return this.http.post<particpantResponse>(AppConfig.appsettings.apiRoot + '/participant', participant).pipe(catchError(this.handleError));
  }

  //Save Dynamics Info
  postDynamics(participant: participantModel): Observable<particpantResponse> {
    return this.http.post<particpantResponse>(AppConfig.appsettings.apiRoot + '/AddPartcipantDynamicOptions', participant).pipe(catchError(this.handleError));
  }

  //Save Question Answer
  postPreScreenerQA(participantResponse: participantResponseModel): Observable<string> {
    return this.http.post<string>(AppConfig.appsettings.apiRoot + '/participantresponse', participantResponse).pipe(catchError(this.handleError));
  }
  postmockPreScreenerQA(participantResponse: participantResponseModel): Observable<string> {
    return this.http.post<string>(AppConfig.appsettings.apiRoot + '/mockparticipantresponse', participantResponse).pipe(catchError(this.handleError));
  }

  //Save general question answer
  //Save Question Answer
  postGeneralrQA(participantResponse: participantResponseModel): Observable<string> {
    return this.http.post<string>(AppConfig.appsettings.apiRoot + '/participantgeneralresponse', participantResponse).pipe(catchError(this.handleError));
  }
  //Save Disclosure
  postDisclosure(disclosure: disclosure): Observable<disclosure> {
    return this.http.put<disclosure>(AppConfig.appsettings.apiRoot + '/participantresult', disclosure).pipe(catchError(this.handleError));
  }

  getApplicantsPhoneFilter(applicantsFilter: applicantsFilter): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/applicantsPhoneFilter', applicantsFilter)
      .pipe(catchError(this.handleError));
  }
  getApplicantsWhentoCallFilter(applicantsFilter: applicantsFilter): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/applicantsWhentoCallFilter', applicantsFilter)
      .pipe(catchError(this.handleError));
  }
  getApplicantsAgeFilter(applicantsFilter: applicantsFilter): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/applicantsAgeFilter', applicantsFilter)
      .pipe(catchError(this.handleError));
  }
  getApplicantsStudynumberFilter(applicantsFilter: applicantsFilter): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/applicantsStudynumberFilter', applicantsFilter)
      .pipe(catchError(this.handleError));
  }
  getApplicantsStatusFilter(applicantsFilter: applicantsFilter): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/applicantsStatusFilter', applicantsFilter)
      .pipe(catchError(this.handleError));
  }
  getapplicantsDobFilter(applicantsFilter: applicantsFilter): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/applicantsDateofBirthFilter', applicantsFilter)
      .pipe(catchError(this.handleError));
  }
  getPrescreenedAgeFilter(filterPrescreened: filterPrescreened): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/prescreenedAgeFilter', filterPrescreened)
      .pipe(catchError(this.handleError));
  }
  getPrescreenedStudynumberFilter(filterPrescreened: filterPrescreened): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/prescreenedStudynumberFilter', filterPrescreened)
      .pipe(catchError(this.handleError));
  } 
  getPrescreenedDateCompletedFilter(filterPrescreened: filterPrescreened): Observable<participantModel[]> {
    return this.http.post<participantModel[]>(AppConfig.appsettings.apiRoot + '/prescreenedDateCompletdFilter', filterPrescreened)
      .pipe(catchError(this.handleError));
  }
  deleteParticipants(participantIds: any): Observable<boolean> {
    return this.http.delete<any>(AppConfig.appsettings.apiRoot + '/DeleteParticipants', { body: participantIds })
      .pipe(
        map((response: Object) => {
          return true;
        }),
        catchError(this.handleError)
      );
  }
  GetRaceOptions(): Observable<RaceModel[]> {
    return this.http.get<RaceModel[]>(AppConfig.appsettings.apiRoot + '/ApplicantRace')
      .pipe(catchError(this.handleError));
  }

  GetApplicantStatus(): Observable<ApplicantStatusModel[]> {
    return this.http.get<ApplicantStatusModel[]>(AppConfig.appsettings.apiRoot + '/GetApplicantStatus')
      .pipe(catchError(this.handleError));
  }

  getStatusReason(): Observable<StatusReasonModel[]> {
    return this.http.get<StatusReasonModel[]>(AppConfig.appsettings.apiRoot + '/GetStatusReason').pipe(catchError(this.handleError));
  }

  getApplicantCommunicationNote(pid: number): Observable<CommunicationNote[]> {
    const params = new HttpParams().set('participantId', pid.toString());
    return this.http.get<CommunicationNote[]>(AppConfig.appsettings.apiRoot + '/GetApplicantCommunicationNote', { params })
    .pipe(catchError(this.handleError));
  }

  SaveApplicantCommunicationNote(communicationNote: CommunicationNote): Observable<string> {
    return this.http.post<string>(AppConfig.appsettings.apiRoot + '/SaveApplicantCommunicationNote', communicationNote).pipe(catchError(this.handleError));
  }

   GetAuditParticipantsBySP(pid: number): Observable<AuditParticipantsBySP[]> {
    const params = new HttpParams().set('participantId', pid.toString());
    return this.http.get<AuditParticipantsBySP[]>(AppConfig.appsettings.apiRoot + '/GetParticipantAuditChanges', { params })
    .pipe(catchError(this.handleError));
  }

  getApplicantStudyNote(pid: number, sid: number): Observable<StudyNote[]> {
    const params = new HttpParams()
      .set('participantId', pid.toString())
      .set('studyId', sid.toString());
    return this.http.get<StudyNote[]>(AppConfig.appsettings.apiRoot + '/GetApplicantStudyNote', { params })
    .pipe(catchError(this.handleError));
  }

  SaveApplicantStudyNote(studyNote: StudyNote): Observable<string> {
    return this.http.post<string>(AppConfig.appsettings.apiRoot + '/SaveApplicantStudyNote', studyNote).pipe(catchError(this.handleError));
  }

  handleError(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }
}
